import { Subscription } from '../services/models/subscription';
import { useAppSelector } from './useAppSelector';

export const useSubscription = (): Subscription => {
  return useAppSelector(state => state.session?.account?.subscription);
};
